import { useTranslation } from 'react-i18next';
import GlobalLoader from '@efex-components/common/GlobalLoader/GlobalLoader';
import useManualPaymentButton from './hooks/useManualPaymentButton';

const PaymentLink = () => {
  const { t } = useTranslation();

  const { loading, error } = useManualPaymentButton();

  return (
    <>
      {loading && <GlobalLoader />}
      {error && <p className="p-2 mb-4">{t('errorLinkManualPaymentButton')}</p>}
    </>
  );
};

export default PaymentLink;
